/* eslint-disable unicorn/no-null -- Formatters deliberately return `null` when no display string is available. */

/**
 * Shared formatting helpers for AI configuration surfaces.
 * Centralizing the token/tweet limit display rules keeps the admin UI and pickers aligned.
 */
export function formatContextTokens(tokens: number | null | undefined): string | null {
  if (typeof tokens !== 'number' || Number.isNaN(tokens) || tokens <= 0) {
    return null;
  }
  if (tokens >= 1_000_000) {
    const millionsRaw = tokens / 1_000_000;
    const millionsRounded = Math.round(millionsRaw * 10) / 10;
    const formatted = Number.isInteger(millionsRounded) ? millionsRounded.toFixed(0) : millionsRounded.toFixed(1);
    return `${formatted}M CONTEXT`;
  }
  if (tokens >= 1000) {
    const thousands = Math.round(tokens / 1000);
    return `${thousands}K CONTEXT`;
  }
  return `${tokens.toLocaleString()} CONTEXT`;
}

export function formatTweetLimit(tweetLimit: number | null | undefined): string | null {
  if (typeof tweetLimit !== 'number' || Number.isNaN(tweetLimit) || tweetLimit <= 0) {
    return null;
  }
  if (tweetLimit >= 1_000_000) {
    const millionsRaw = tweetLimit / 1_000_000;
    const millionsRounded = Math.round(millionsRaw * 10) / 10;
    const formatted = Number.isInteger(millionsRounded) ? millionsRounded.toFixed(0) : millionsRounded.toFixed(1);
    return `Up to ${formatted}M tweets`;
  }
  if (tweetLimit >= 1000) {
    const thousands = Math.round(tweetLimit / 1000);
    return `Up to ${thousands}K tweets`;
  }
  return `Up to ${tweetLimit.toLocaleString()} tweets`;
}
